(() => {
  const root = document.querySelector('.ao-shirt-product');
  if (!root || root.dataset.linkedMotifsBound) return;
  root.dataset.linkedMotifsBound = 'true';
  const update = () => {
    const size = root.querySelector('[data-size-group] [data-option-button].is-selected')?.dataset.optionValue;
    const lang = root.querySelector('[data-lang-group] [data-option-button].is-selected')?.dataset.optionValue;
    root.querySelectorAll('[data-ao-linked-motif]').forEach(link => {
      const variants = JSON.parse(link.querySelector('[data-ao-linked-variants]').textContent);
      const variant = variants.find(v => (!size || v.option2 === size) && (!lang || v.option3 === lang));
      if (variant) link.href = link.dataset.productUrl + '?variant=' + variant.id;
    });
  };
  root.addEventListener('click', e => { if (e.target.closest('[data-option-button]')) queueMicrotask(update); });
  update();
})();
